module.exports = __webpack_public_path__ + "static/media/test-pineapple.ae8de97a.jpg";